import script from "./TurningPointIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./TurningPointIndicator.vue?vue&type=script&setup=true&lang=js"

import "./TurningPointIndicator.vue?vue&type=style&index=0&id=74835376&lang=scss"

const __exports__ = script;

export default __exports__